import Base from './Base';
import TollFreeProfile from '../models/TollFreeProfile';

export default class TollFreeProfiles extends Base {
    get models() {
        const collection = this.data.map(item => new TollFreeProfile(item));
        collection.collection = this;

        return collection;
    }
}
